<template>
	<dropdown :class='{wide: wideWindow, activeFilter: filtered, right_align: rightAlign, filter}' :text='name' v-model='val' @input='open'>
		<div class='loading-wrap' v-if='loading'>
			<i class='fa fa-spinner fa-spin' style='font-size:26px;'></i>
		</div>
		<div class='heading'>
			Период
		</div>
		<!-- -->
		<div class='inputs_wrap'>
			<div class='column'>
				От <datepicker
					v-model='from'
					format='dd.MM.yyyy'
					class='table-control'
				></datepicker>
			</div>
			<div class='column'>
				До <datepicker
					v-model='to'
					format='dd.MM.yyyy'
					class='table-control'
				></datepicker>
			</div>
		</div>
		<!-- -->
		<li role="separator" class="divider"></li>
		<!-- -->
		<li class='pull-right'>
			<input type="button" class='btn btn-primary' value='Ок' @click='ok'/>
			<input type="button" class='btn btn-default' value='Отмена' @click='cancel'/>
		</li>
	</dropdown>
</template>

<script>
	import { dropdown, checkbox, datepicker } from 'vue-strap'
	import { EventBus } from '../lib/EventBus'
	import {DB} from '../constants'
	import moment from 'moment'

	const FILTER = 'get_filter.php'
	const LIST_OFFSET = 20

	export default {
		name: 'FilterDateRange',
		data () {
			return {
				from: '',
				to: '',
				all_items: [],
				items: [],
				offset: 0,
				sel: true,
				val: false,
				filtered: false,
				saved_items: [],
				loading: false,
				text: '',
				scrollDebounce: false,
				FILTER: null,
				flag: false
			}
		},
		props: [
			'name',
			'field',
			'filter',
			'suffix',
			'wideWindow',
			'rightAlign'
		],
		components: {
			dropdown,
			checkbox,
			datepicker
		},
		watch: {
			sel (e) {
				this.all_items.map(t => {
					t.checked = e
				})
			},
			text (s) {
				if(s && s.length)
				{
					this.items = []
					for(let line of this.all_items)
					{
						const needle = s.toLowerCase()
						if(line.value.toLowerCase().indexOf(needle) !== -1)
						{
							let temp_line = line
							const regexp = new RegExp(`(${needle})`,"i")
							temp_line.show_value = temp_line.value.replace(regexp, '<span class="needle">$1</span>')
							this.items.push(temp_line)
						}
					}
					this.setCheckedToItems()		
				} else {
					this.items = this.all_items.slice(0, this.offset)
				}
				this.$forceUpdate()
			}
		},
		methods: {
			checkboxInput (value, rank) {
				//console.warn(value, rank)
				//const
				//for(let i in this.all_items)
				//	if(this.all_items[i].dense_rank == rank)

				//console.warn(value, rank)

				this.all_items[+rank].checked = value

				const result = []
				for(let item of this.all_items) {
					if(item.checked)
						result.push(item.value)
				}

				this.filtered = (result.length !== this.all_items.length) && (result.length !== 0)
				//EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})
				
				//console.warn(this.all_items[81])
			},
			setCheckedToItems () {
				for (let i = 0; i < this.items.length; i++) {
					//if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
						/*this.sel = false
						this.items[i].checked = false
						let flag = false
						for (let j = 0; j < this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value.length; j++) {
							if (this.items[i].value === this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value[j]) {
								this.items[i].checked = true
								flag = true
							}
							else if (!flag) {
								this.items[i].checked = false
								flag = false
							}
						}*/
					// else {
					//	const rank = this.items[i].rank
					//	this.items[i].checked = this.sel ? true : this.all_items[+rank].checked
					//}
				}
			},
			listScrollHandler (e) {
				if(this.text)
					return false

				if(this.scrollDebounce) {
					setTimeout(() => {
						this.scrollDebounce = false
						this.listScrollHandler(e)
					}, 500)
					return false
				}
					
				if(e.target.scrollTop + e.target.clientHeight + 100 >= e.target.scrollHeight && this.offset < this.all_items.length) {
					this.scrollDebounce = true
					setTimeout(() => this.scrollDebounce = false, 500)

					this.offset += LIST_OFFSET
					this.items = this.all_items.slice(0, this.offset)
					this.setCheckedToItems()
				}
			},
			ok () {
				this.val = false
				this.text = ''
				let result = []

				result.push(this.from, this.to)
				this.filtered = true

				EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})
				EventBus.$emit('filter' + (this.suffix ? this.suffix : '') + '_list', {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})
			},
			cancel () {
				this.val = false
			},
			open (show) {
				if (show) {
					if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
						[this.from, this.to] = this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value
					}
				}
			},
			fill () {
				fetch(DB + this.FILTER + '?field=' + this.field + '&filter=')
				.then(res => res.json())
				.then(res => {
					if (res) {
						let arr = res.map(r => {
							return {
								value: r[this.field] ? (this.field !== 'act_placement_date' ? r[this.field] : moment(r[this.field], 'YYYY-MM-DD').format('DD.MM.YYYY')) : '',
								checked: true
							}
						})
						this.all_items = arr
					}
					else {
						this.all_items = []
					}
				})
				.catch(err => console.log(err))
			}
		},
		created () {
			if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
				this.filtered = this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].filtered
			}
			else {
				this.saved_items = []
			}

			EventBus.$on('clearFilters' + (this.suffix ? this.suffix : ''), f => {
				this.filtered = false
				this.sel = true
				this.all_items = []
				this.fill()
				EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: [], filtered: false, cf: true})
				EventBus.$emit('filter' + (this.suffix ? this.suffix : '') + '_list', {field: this.field, value: [], filtered: false, cf: true})
			})
		},
		mounted () {
			this.FILTER = 'get_filter' + (this.suffix ? this.suffix : '') + '.php'
		},
		beforeDestroy () {
			EventBus.$off('clearFilters'+ (this.suffix ? this.suffix : ''))
		}
	}

</script>

<style scoped>
.inputs_wrap {
	display: flex; 
	width: 280px;
	overflow: visible; 
	max-height: 400px
}

.column {
	width: 50%;
}

.inputs_wrap .datepicker {
	width: 100px;
}

.heading {
	font-weight: 700;
	text-align: center;
	margin-bottom: 15px;
}
</style>

<style>
	.activeFilter, .activeFilter > .dropdown-toggle {
		background-color: lightgreen !important;
		/*color: white;*/
	}

	div.filter, button.dropdown-toggle {
		width: 100%;
		/*height: 40%;*/
		padding-top: 0px;
		padding-bottom: 0px;
	}

	button.dropdown-toggle {
	 	font-weight: bold; 
		border: none;
	}

	ul.dropdown-menu {
		padding-left: 10px;
		padding-right: 10px;
		/*max-height: 500px;*/
		min-width: 200px;
		/*overflow-y: auto;*/
	}

	.loading-wrap {
		position: absolute;
	    left: 0;
	    right: 0;
	    z-index: 1000;
	    top: 0;
	    bottom: 49px;
	    background: rgba(255,255,255,0.8);
	    display: flex;
    	align-items: center;
    	justify-content: center;
	} 

	.wide > .dropdown-menu {
		min-width: 320px;
	}

	.right_align > .dropdown-menu {
		right: 0;
    	left: unset;
	}

	.colored {
		color: #888;
	}

	.needle {
		color: #000;
	}
</style>


// WEBPACK FOOTER //
// FilterDateRange.vue?f1eba492